export default {
    /* Making a request to the server to get a new CSRF token. */
    refreshTokens() {
        return axios
            .get("/")
            .then(({ data }) => {
                const wrapper = document.createElement("div");
                wrapper.innerHTML = data;
                return wrapper
                    .querySelector("meta[name=csrf-token]")
                    .getAttribute("content");
            })
            .then((token) => {
                window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token;
                document
                    .querySelector("meta[name=csrf-token]")
                    .setAttribute("content", token);
                return token;
            });
    },
};
